export default "__VITE_ASSET__7cfp2Ifv__"